import jQuery from 'jquery';

export default function translate() {
    jQuery(() => {
        const $ = jQuery;

        $('.header__toolbar-lang a')
            .on('click', (e) => {
                e.preventDefault();

                const that = e.currentTarget;

                $(that)
                    .next()
                    .toggleClass('visible');
            });



        window.triggerHtmlEvent = function (element, eventName) {
            let event;
            if (document.createEvent) {
                event = document.createEvent('HTMLEvents');
                event.initEvent(eventName, true, true);
                element.dispatchEvent(event);
            } else {
                event = document.createEventObject();
                event.eventType = eventName;
                element.fireEvent(`on${event.eventType}`, event);
            }
        };

        jQuery('.lang-select')
            .click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                console.log('lang-select clicked', jQuery(this).attr('href'));
                const hash = jQuery(this).attr('href');
                const url = new URL(window.location.href);
                url.searchParams.set('t', Date.now());
                url.hash = hash.replace('#', '');
                console.log('navigating to', url.toString());
                window.location.href = url.toString();
            });
    });
}
